import { render } from "./Vehicles.vue?vue&type=template&id=10f1edd8&scoped=true&bindings={\"addEditVehicle\":\"data\",\"dsInsert\":\"data\",\"editIndex\":\"data\",\"continueToExtras\":\"options\",\"saveVehicle\":\"options\",\"editVehicle\":\"options\",\"deleteVehicle\":\"options\",\"insertVehicle\":\"options\",\"isMakeValid\":\"options\",\"isModelValid\":\"options\",\"isRegistrationValid\":\"options\",\"isValidated\":\"options\"}"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

import "./Vehicles.vue?vue&type=style&index=0&id=10f1edd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10f1edd8"

export default script